import { RequireAccess } from '@/components'
import { ExternalConnectionsPage } from '@/ui'
import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute(
	'/_auth/company/$companyId/settings/external-connections',
)({
	component: RouteComponent,
})

function RouteComponent() {
	const { companyId } = Route.useParams()

	return (
		<RequireAccess
			role="jobillan"
			fallback={<Navigate to="/company/$companyId/settings" params={{ companyId }} replace={true} />}
		>
			<ExternalConnectionsPage />
		</RequireAccess>
	)
}
